var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, CustomElement, COMPONENT_STATE, html, Watch, Event, EventEmitter, directive, nothing } from '@sick-davinci/ce-decorators';
import { style } from './NumericField.style';
import { Button } from '../button/Button';
const keyCodeArrowLeft = 37;
const keyCodeArrowUp = 38;
const keyCodeArrowRight = 39;
const keyCodeArrowDown = 40;
const useTouchEvents = 'onpointerdown' in document.documentElement || 'ontouchstart' in document.documentElement;
const set = new WeakMap(); // WeakSet needs Polyfill, weak map is built in

const pressEventType = 'onpointerdown' in document ? 'pointerdown' : 'ontouchstart' in document ? 'touchstart' : 'mousedown';
const releaseEventType = 'onpointerdown' in document ? 'pointerup' : 'ontouchstart' in document ? 'touchend' : 'mouseup';
const cancelEventType = 'onpointerdown' in document ? 'pointercancel' : 'ontouchstart' in document ? 'touchend' : 'mouseleave';
const pressEventDirective = directive(callback => part => {
  if (set.has(part)) {
    return;
  } else {
    part.element.addEventListener(pressEventType, callback);
    set.set(part, true);
  }
});
/**
 * A number field is a text field that only allows to enter numbers.
 * The numeric field has addional functionality to increase and decrease numbers without typing anything.
 * 
 * @example
 * ```html
 * <davinci-numeric-field value="50"></davinci-numeric-field>
 * ```
 * @slot { * } content of the link
 */

export let NumericField = (_dec = Component({
  style: [style],
  tag: 'davinci-numeric-field',
  dependencies: [Button]
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Number), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Number), _dec10 = Prop({
  type: String
}), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop({
  type: String
}), _dec13 = Reflect.metadata("design:type", String), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", String), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", Boolean), _dec20 = Event(), _dec21 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec22 = Event(), _dec23 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec24 = Prop({
  reflectAsAttribute: false
}), _dec25 = Reflect.metadata("design:type", Number), _dec26 = Watch('disabled'), _dec27 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec28 = Watch('min'), _dec29 = Reflect.metadata("design:paramtypes", []), _dec30 = Watch('max'), _dec31 = Reflect.metadata("design:paramtypes", []), _dec(_class = (_class2 = (_temp = class NumericField extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "type", _descriptor, this);

    _initializerDefineProperty(this, "min", _descriptor2, this);

    _initializerDefineProperty(this, "max", _descriptor3, this);

    _initializerDefineProperty(this, "ticks", _descriptor4, this);

    _initializerDefineProperty(this, "groupSeparator", _descriptor5, this);

    _initializerDefineProperty(this, "decimalSeparator", _descriptor6, this);

    _initializerDefineProperty(this, "formatPattern", _descriptor7, this);

    _initializerDefineProperty(this, "unit", _descriptor8, this);

    _initializerDefineProperty(this, "disabled", _descriptor9, this);

    _initializerDefineProperty(this, "change", _descriptor10, this);

    _initializerDefineProperty(this, "input", _descriptor11, this);

    this._internalValue = 0;
    this._direction = 1;
    this._incrementInterval = null;
    this._holdTimeout = null;
    this._changeTimeout = null;

    this.onChange = () => {
      let value = this._elementInput.value; // Replace last comma with a dot

      if (isNaN(Number(value))) {
        value = this._elementInput.value.replace(/,(?=[^,]*$)/, '.');
      } // If it's still not valid, show last valid value


      if (isNaN(Number(value))) {
        value = this.value.toString();
        this._elementInput.value = value;
      }

      this.value = Number(value);
      this.change.emit(this.value);
    };

    this.keyboardDownEvent = event => {
      if (event.keyCode === keyCodeArrowDown || event.keyCode === keyCodeArrowLeft) {
        this._setButtonTo('.decrease', true);

        this._direction = -1;

        this._updateValue();

        this.input.emit(this.value);
        event.preventDefault();
      } else if (event.keyCode === keyCodeArrowUp || event.keyCode === keyCodeArrowRight) {
        this._setButtonTo('.increase', true);

        this._direction = 1;

        this._updateValue();

        this.input.emit(this.value);
        event.preventDefault();
      }
    };

    this.keyboardUpEvent = event => {
      if (event.keyCode === keyCodeArrowDown || event.keyCode === keyCodeArrowLeft) {
        this._setButtonTo('.decrease', false);

        this.change.emit(this.value);
        event.preventDefault();
      } else if (event.keyCode === keyCodeArrowUp || event.keyCode === keyCodeArrowRight) {
        this._setButtonTo('.increase', false);

        this.change.emit(this.value);
        event.preventDefault();
      }
    };

    this.onClickIncrease = event => {
      this._direction = 1;
      this.spinStartEventListener(event);
    };

    this.onClickDecrease = event => {
      this._direction = -1;
      this.spinStartEventListener(event);
    };

    this.spinStartEventListener = event => {
      event.preventDefault();
      event.stopPropagation();

      if (this._changeTimeout !== null) {
        window.clearTimeout(this._changeTimeout);
        this._changeTimeout = null;
      }

      document.addEventListener(releaseEventType, this.spinEndListener);

      if (useTouchEvents) {
        document.addEventListener(cancelEventType, this.spinEndListener);
      }

      this._updateValue();

      this.input.emit(this.value);
      this._holdTimeout = window.setTimeout(() => {
        this._incrementInterval = window.setInterval(() => {
          this._updateValue();

          this.input.emit(this.value);
        }, 25);
      }, 500);
    };

    this.spinEndListener = event => {
      event.preventDefault();
      event.stopPropagation();
      document.removeEventListener(releaseEventType, this.spinEndListener);

      if (useTouchEvents) {
        document.removeEventListener(cancelEventType, this.spinEndListener);
      }

      window.clearTimeout(this._holdTimeout);
      this._holdTimeout = null;
      window.clearInterval(this._incrementInterval);
      this._incrementInterval = null;
      this._changeTimeout = window.setTimeout(() => {
        this._changeTimeout = null;
        this.change.emit(this.value);

        this._setButtonTo('.decrease', false);
      }, 500);
    };
  }

  /**
   * Get the value of the numeric field.
   */
  get value() {
    return this._internalValue;
  }
  /**
   * Set the value of the numeric field.
   */


  set value(value) {
    this._check(value);

    if (this._elementInput !== undefined) {
      this._elementInput.value = this.format(this._internalValue);
    }
  }

  render() {
    return html`
    <div class="wrapper">
      <davinci-button type="${this.type}" class="decrease" icon="content/remove"
        ?disabled="${this.isMinDisabled()}" @="${pressEventDirective(this.onClickDecrease)}"></davinci-button>
      <input
        class="input"
        type="text"
        pattern="\d*"
        size="1"
        value="${this.value}"
        @change=${this.onChange}>
      </input>
      <davinci-button type="${this.type}" class="increase" icon="content/add"
        ?disabled="${this.isMaxDisabled()}" @="${pressEventDirective(this.onClickIncrease)}"></davinci-button>
      ${this.renderUnit()}
    </div>`;
  }

  componentConnected() {
    this.addEventListener('keydown', this.keyboardDownEvent);
    this.addEventListener('keyup', this.keyboardUpEvent);
    this.disabledChangeHandler(this.disabled, this.disabled);
  }

  componentDisconnected() {
    this.removeEventListener('keydown', this.keyboardDownEvent);
    this.removeEventListener('keyup', this.keyboardUpEvent);
  }

  componentFirstRender() {
    this._elementInput = this.shadowRoot.querySelector('input');
    this._elementInput.value = this.format(this._internalValue); // Otherwise the calculated width has no effect

    this.scheduleRender();
  }

  disabledChangeHandler(_, newValue) {
    if (this._componentState !== COMPONENT_STATE.INIT) {
      // avoid setting illegal attribute set during construction
      if (!newValue) {
        // with this code the focused slider has a blue highlighting-box
        this.setAttribute('tabindex', '0');
      }
    }
  }

  updateMin() {
    if (this._internalValue !== undefined) {
      this._internalValue = this._internalValue <= this.min ? this.min : this._internalValue;
    }
  }

  updateMax() {
    if (this._internalValue !== undefined) {
      this._internalValue = this._internalValue >= this.max ? this.max : this._internalValue;
    }
  }

  isMinDisabled() {
    return this.disabled || this.value <= this.min ? true : false;
  }

  isMaxDisabled() {
    return this.disabled || this.value >= this.max ? true : false;
  }

  renderUnit() {
    return this.unit !== undefined ? html`<span class="unit">${this.unit}</span>` : nothing;
  }
  /*
  * Took from Javascript Formatter: IntegraXor Web SCADA -JavaScript Number Formatter http://www.integraxor.com/ for license see LICENSE file
  */


  format(value) {
    // tslint:disable-line
    if (!this.formatPattern || isNaN(+value)) {
      // tslint:disable-line
      return value + ''; // return as it is.
    } // Convert any string to number according to formation sign.


    value = this.formatPattern.charAt(0) == '-' ? -value : +value; // tslint:disable-line
    // Process only abs(), and turn on flag.

    const isNegative = value < 0 ? value = -value : 0; // tslint:disable-line
    // Search for separator for group & decimal, anything not digit, not +/- sign, not #.

    const result = this.formatPattern.match(/[^\d\-\+#]/g); // Treat the right most symbol as decimal

    const decimal = result && result[result.length - 1] || '.'; // Treat the left most symbol as group separator

    const group = result && result[1] && result[0]; // Split the decimal for the format string if any.

    const formatPattern = this.formatPattern.split(decimal); // Fix the decimal first, toFixed will auto fill trailing zero.

    value = value.toFixed(formatPattern[1] && formatPattern[1].length); // tslint:disable-line
    // convert number to string to trim off *all* trailing decimal zero(es)

    value = +value + ''; // tslint:disable-line
    // Fill back any trailing zero according to format
    // Look for last zero in format

    const posTrailZero = formatPattern[1] && formatPattern[1].lastIndexOf('0');
    const part = value.split('.'); // tslint:disable-line
    // Integer will get !part[1]

    if (!part[1] || part[1] && part[1].length <= posTrailZero) {
      // tslint:disable-line
      value = (+value).toFixed(posTrailZero + 1); // tslint:disable-line
    } // Look for separator


    const szSep = formatPattern[0].split(group); // Join back without separator for counting the pos of any leading 0.

    formatPattern[0] = szSep.join('');
    const posLeadZero = formatPattern[0] && formatPattern[0].indexOf('0');

    if (posLeadZero > -1) {
      while (part[0].length < formatPattern[0].length - posLeadZero) {
        // tslint:disable-line
        part[0] = '0' + part[0]; // tslint:disable-line
      }
    } else if (+part[0] === 0) {
      // tslint:disable-line
      part[0] = ''; // tslint:disable-line
    }

    const valueSplitted = value.split('.'); // tslint:disable-line

    valueSplitted[0] = part[0]; // tslint:disable-line
    // Process the first group separator from decimal (.) only, the rest ignore.
    // Get the length of the last slice of split result.

    const posSeparator = szSep[1] && szSep[szSep.length - 1].length;

    if (posSeparator) {
      const integer = valueSplitted[0];
      let str = '';
      const offset = integer.length % posSeparator;

      for (let i = 0, l = integer.length; i < l; i++) {
        // IE6 only support charAt for sz.
        str += integer.charAt(i); // -pos_separator so that won't trail separator on full length

        if (!((i - offset + 1) % posSeparator) && i < l - posSeparator) {
          if (group) {
            str += this.groupSeparator;
          }
        }
      }

      valueSplitted[0] = str;
    }

    valueSplitted[1] = formatPattern[1] && valueSplitted[1] ? this.decimalSeparator + valueSplitted[1] : ''; // Put back any negation and combine integer and fraction.

    const stringValue = (isNegative ? '-' : '') + valueSplitted[0] + valueSplitted[1];
    return stringValue;
  }

  _updateValue() {
    this.value = this.value + this.ticks * this._direction;
  }

  _check(value) {
    let val = value === undefined || value === null ? this.value : value;

    if (this.min !== null && val < this.min) {
      val = this.min;
    } else if (this.max !== null && val > this.max) {
      val = this.max;
    }

    this._internalValue = val;
  }

  _setButtonTo(selector, selected) {
    if (selected) {
      this.shadowRoot.querySelector(selector).setAttribute('toggle', 'true');
      this.shadowRoot.querySelector(selector).setAttribute('selected', 'true');
    } else {
      this.shadowRoot.querySelector(selector).removeAttribute('toggle');
      this.shadowRoot.querySelector(selector).removeAttribute('selected');
    }
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'outline';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "min", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "max", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 100;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "ticks", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "groupSeparator", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ',';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "decimalSeparator", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '.';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "formatPattern", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '0';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "unit", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "value", [_dec24, _dec25], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disabledChangeHandler", [_dec26, _dec27], Object.getOwnPropertyDescriptor(_class2.prototype, "disabledChangeHandler"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateMin", [_dec28, _dec29], Object.getOwnPropertyDescriptor(_class2.prototype, "updateMin"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateMax", [_dec30, _dec31], Object.getOwnPropertyDescriptor(_class2.prototype, "updateMax"), _class2.prototype)), _class2)) || _class);
//# sourceMappingURL=NumericField.js.map